import * as types from '../../constants/actionsType'
import moment from 'moment';
const initialState = {
  TableEmployeeWise: {
    head: [
      "ID", "Name", "Project", "Module", "StartDate", "EndDate", "ReportingID"
    ],
    body: []
  },
  projectList: [],
  TaskList: [],
  UserList: [],
  MonthDate: [],
  SelectMonth: "",
  EmployeesUtilize: {
    head: [],
    body: []
  },
  loading: true,
  milestones: [],
  role: 0,
  taskUpdateLoader: false,
  taskCompleteLoader: false,
  taskUpdateSuccess: false,
  taskSpentTimeList: [],
  loaderSpentTimeList: false
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CAPACITY_PLAN:
      var date = moment().format("MMM YYYY");
      var tableData
      if (action.superUser && action.switchlevel == 3 && action.View == 'E') {
        tableData = nonTree(action.data, "ID", "ReportingID");
      } else {
        tableData = tree(action.data, "ID", "ReportingID");
      }
      var projectData = [];
      var myTask = []
      if (action.switchlevel == 2 || action.role == 3) {
        var taskdata = [];
        if (action.View == "P") {
          taskdata = action.data.filter(e => e.Project != "");
        } else {
          taskdata = action.data
        }
        const result1 = Object.entries(taskdata.reduce((acc, { Project, ID, TaskID, TaskAccessID, Module, Name, EstHrs, StatusID, Status, StartDate, EndDate, DisplayDate, CountTask, DisplayDetails }) => {
          if (action.View != "P") {
            acc[Name] = (acc[Name] || []);
            acc[Name].push({ Project, ID, TaskID, TaskAccessID, Module, Name, EstHrs, StatusID, Status, StartDate, EndDate, DisplayDate, CountTask, DisplayDetails });
            return acc;
          } else {
            acc[Project] = (acc[Project] || []);
            acc[Project].push({ Project, ID, TaskID, TaskAccessID, Module, Name, EstHrs, StatusID, Status, StartDate, EndDate, DisplayDate, CountTask, DisplayDetails });
            return acc;
          }
        }, {})).map(([key, value]) => ({ Name: key, children: value }));
        myTask = result1;
      }

      if (action.View == "P") {
        var taskData = action.data.filter(e => e.Project != '');
        const result = Object.entries(taskData.reduce((acc, { Project, ID, TaskID, TaskAccessID, Module, Name, EstHrs, StatusID, Status, StartDate, EndDate, DisplayDate, CountTask, DisplayDetails }) => {
          acc[Project] = (acc[Project] || []);
          acc[Project].push({ Project, ID, TaskID, TaskAccessID, Module, Name, EstHrs, StatusID, Status, StartDate, EndDate, DisplayDate, CountTask, DisplayDetails });
          return acc;
        }, {})).map(([key, value]) => ({ Name: key, children: value }));
        projectData = result;
      } else {
        if (tableData.length > 0) {
          tableData = tableData.sort(function (a, b) {
            var nameA = a.Name.toUpperCase(); // ignore upper and lowercase
            var nameB = b.Name.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }

            // names must be equal
            return 0;
          });
          tableData.map((e, i) => {
            if (tableData[i].Name == e.Name) {
              tableData[i].Name = e.Name.charAt(0).toUpperCase() + e.Name.slice(1);
              if (e.children.length > 0) {
                tableData[i].children = e.children.sort(function (a, b) {
                  var nameA = a.Name.toUpperCase(); // ignore upper and lowercase
                  var nameB = b.Name.toUpperCase(); // ignore upper and lowercase
                  if (nameA < nameB) {
                    return -1;
                  }
                  if (nameA > nameB) {
                    return 1;
                  }

                  // names must be equal
                  return 0;
                });
                e.children.map((el, index) => {
                  tableData[i].children[index].Name = el.Name.charAt(0).toUpperCase() + el.Name.slice(1);
                })
              }
            }
          })
        }
      }
      var listMilestone = [];
      action.milestones != undefined && action.milestones.length > 0 && action.milestones.map((e) => {
        //we will change milestone and milestone to task and taskID 
        listMilestone.push({
          name: e.Task,
          value: e.TaskID,
          ProjectID: e.ProjectID
        })
      })
      listMilestone = listMilestone.length > 0 ? listMilestone.sort(function (a, b) {
        var nameA = a.name?.toUpperCase(); // ignore upper and lowercase
        var nameB = b.name?.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      }) : []
      if (action.superUser && action.switchlevel == 3 && action.View == 'E') {
        bodyData = tableData;
      } else {
        var bodyData = action.switchlevel == 2 || action.role == 3 ? myTask : action.View == "P" ? projectData.filter(e => e.name != "") : tableData
      }

      return {
        ...state,
        TableEmployeeWise: {
          body: bodyData
        },
        projectList: action.projectList,
        TaskList: action.data,
        UserList: action.userData,
        SelectMonth: state.SelectMonth,
        milestones: listMilestone,
        role: action.role
      }
    case types.GET_CAPACITY_PLAN_GET_MONTH: {
      var date = moment(action.data[0]).format("MMM YYYY");
      return {
        ...state,
        MonthDate: action.data,
        SelectMonth: date
      }
    }
    case types.GET_EMPLOYEES_UTILIZATION: {
      return {
        ...state,
        EmployeesUtilize: []
      }
    }
    case types.GET_CAPACITY_PLAN_LOADING: {
      return {
        ...state,
        loading: action.loading
      }
    }
    case types.GET_CAPACITY_PLAN_CHANGE_LEVEL: {
      return {
        ...state,
        TableEmployeeWise: {
          head: [
            "ID", "Name", "Project", "Module", "StartDate", "EndDate", "ReportingID"
          ],
          body: []
        },
        projectList: [],
        TaskList: [],
        UserList: [],
        MonthDate: [],
        SelectMonth: "",
        EmployeesUtilize: {
          head: [],
          body: []
        },
        loading: true,
        milestones: []
      }
    }

    case types.GET_UPDATE_ROLE: {
      return {
        ...state,
        TableEmployeeWise: {
          head: [
            "ID", "Name", "Project", "Module", "StartDate", "EndDate", "ReportingID"
          ],
          body: []
        },
        projectList: [],
        TaskList: [],
        UserList: [],
        MonthDate: [],
        SelectMonth: "",
        EmployeesUtilize: {
          head: [],
          body: []
        },
        loading: true,
        milestones: [],
        role: 0
      }
    }

    case types.GET_FAILED_EMPLOYEE_VIEW: {
      return {
        ...state,
        TableEmployeeWise: {
          head: [
            "ID", "Name", "Project", "Module", "StartDate", "EndDate", "ReportingID"
          ],
          body: []
        },
        projectList: [],
        TaskList: [],
        UserList: [],
        EmployeesUtilize: {
          head: [],
          body: []
        },
        loading: false,
        milestones: [],
        role: 0
      }
    }

    case types.COMPLETE_TASK: {
      return {
        ...state,
        taskUpdateLoader: false
      }
    }

    case types.UPDATE_TASK_LOADER: {
      return {
        ...state,
        taskUpdateLoader: action.data
      }
    }

    case types.COMPLETE_TASK_LOADER: {
      return {
        ...state,
        taskCompleteLoader: action.data
      }
    }

    case types.UPDATE_TASK_SUCCESS: {
      return {
        ...state,
        taskUpdateSuccess: action.data
      }
    }

    case types.UPDATE_TASK_SPENT_TIME: {
      return {
        ...state,
        taskSpentTimeList: action.data
      }
    }

    case types.LOAD_TASK_TIME_SPENT: {
      return {
        ...state,
        loaderSpentTimeList: action.data
      }
    }

    default:
      return state
  }
}

//Month Date getting
function getDaysInMonth(month, year) {
  var date = new Date(year, month);
  var days = [];
  while (date.getMonth() === month) {
    days.push(new Date(date));
    date.setDate(date.getDate() + 1);
  }
  return days;
}

function tree(data, id, pId) {
  if (data == []) {
    return []
  }
  const [result] = data.reduce(
    ([r, map], item) => {
      const d = { Name: item.Name, Project: item.Project, UserID: item.ID, TaskID: item.TaskID, TaskAccessID: item.TaskAccessID, Module: item.Module, EstHrs: item.EstHrs, StatusID: item.StatusID, Status: item.Status, StartDate: item.StartDate, EndDate: item.EndDate, ReportingID: item.ReportingID, DisplayDate: item.DisplayDate, children: [], parent: false, CountTask: item.CountTask, DisplayDetails: item.DisplayDetails };
      const loc = map[item[pId]];
      if (loc) {
        d.parent = true
        loc.children.push(d);
      } else {
        r.push(d);
      }
      map[item[id]] = d;
      return [r, map];
    },
    [[], {}]
  );
  return result;
}


function nonTree(data, id, pId) {
  if (data == []) {
    return []
  }
  const [result] = data.reduce(
    ([r, map], item) => {
      const d = { Name: item.Name, Project: item.Project, UserID: item.ID, TaskID: item.TaskID, TaskAccessID: item.TaskAccessID, Module: item.Module, EstHrs: item.EstHrs, StatusID: item.StatusID, Status: item.Status, StartDate: item.StartDate, EndDate: item.EndDate, ReportingID: item.ReportingID, DisplayDate: item.DisplayDate, children: [], parent: false, CountTask: item.CountTask, DisplayDetails: item.DisplayDetails };
      const loc = map[item[pId]];
      // if (loc) {
      //   d.parent = true
      //   loc.children.push(d);
      // } else {
      r.push(d);
      // }
      map[item[id]] = d;
      return [r, map];
    },
    [[], {}]
  );
  return result;
}


export default reducer